"use client";

import * as React from "react";
import dynamic from "next/dynamic";
import { ArrowRight } from "lucide-react";

import type { CoreServiceWithPlans } from "@/app/_lib/db/core-service";
import type { SolutionWithInclude } from "@/app/_lib/db/solutions";

// Not needed until the user clicks "Start a new conversation" — load only on the client.
const GuestChatSimulator = dynamic(
  () => import("@/app/_components/guest-chat/simulator"),
  { ssr: false },
);

interface Props {
  services: Pick<CoreServiceWithPlans, "id" | "title">[];
  solutions: Pick<SolutionWithInclude, "id" | "headTitle">[];
}

export default function StartConversationButton({ services, solutions }: Props) {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="flex justify-center w-full items-center gap-2 rounded-full bg-primary px-5 py-4 text-lg font-semibold transition-opacity hover:opacity-90 text-primary-foreground duration-300 font-normal"
      >
        Start a new conversation <ArrowRight size={15} />
      </button>
      <GuestChatSimulator
        open={open}
        onClose={() => setOpen(false)}
        services={services}
        solutions={solutions}
        type="SALES"
      />
    </>
  );
}
